<template>
  <BaseDialog
    center
    title="设置展示信息"
    width="870px"
    :model-value="true"
    :before-close="props.remove"
    :close-on-press-escape="true"
  >
    <BaseRow style="padding: 20px">
      <BaseCol :span="12">
        <span style="font-weight: bold">基本信息</span>
        <div style="margin: 10px 0">
          <BaseCheckbox v-model="basic" @change="basicCheckAll">
            全选
          </BaseCheckbox>
        </div>
        <BaseCheckboxGroup v-model="checkedBasic" @change="basicChecked">
          <div
            style="display: flex; align-items: center; margin-bottom: 16px"
            v-for="(item, index) in basicList"
            :key="index"
          >
            <BaseCheckbox
              @change="
                e => {
                  clearCheck(e, index, 'basicList');
                }
              "
              :value="'basic' + item.prop"
              :label="'basic' + item.prop"
            ></BaseCheckbox>
            <BaseTooltip
              v-if="
                item.dataType === 1 ||
                item.dataType === 4 ||
                item.dataType === 5
              "
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <BaseInput
                style="width: 350px"
                :placeholder="item.label"
                v-model="item.conditionKey"
                :disabled="
                  !checkedBasic.includes('basic' + item.prop) ||
                  item.disable === 1
                "
              ></BaseInput>
            </BaseTooltip>
            <BaseDatePicker
              v-else-if="item.dataType === 2"
              v-model="item.conditionKey"
              type="daterange"
              :start-placeholder="item.label + '起'"
              :end-placeholder="item.label + '止'"
              :disabled="!checkedBasic.includes('basic' + item.prop)"
            ></BaseDatePicker>
            <BaseDatePicker
              v-else-if="item.dataType === 6"
              v-model="item.conditionKey"
              type="monthrange"
              range-separator="至"
              :start-placeholder="item.label + '起'"
              :end-placeholder="item.label + '止'"
              :disabled="!checkedBasic.includes('basic' + item.prop)"
            ></BaseDatePicker>

            <BaseTooltip
              v-else-if="[3, 7].includes(item.dataType)"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <BaseSelect
                v-model="item.conditionKey"
                clearable
                filterable
                collapse-tags
                :placeholder="item.label"
                :disabled="!checkedBasic.includes('basic' + item.prop)"
                :options="item.options"
              ></BaseSelect>
            </BaseTooltip>
            <BaseTooltip
              v-if="item.dataType === 31"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <BaseAutocomplete
                :placeholder="item.label"
                v-model="item.conditionKey"
                :maxlength="30"
                :fetch-suggestions="
                  (queryString, cb) => {
                    cb(
                      item.options.filter(
                        i => !queryString || i.value?.indexOf(queryString) > -1
                      )
                    );
                  }
                "
                @select="
                  item => {
                    item.conditionKey = item.value;
                  }
                "
                :disabled="
                  !checkedBasic.includes('basic' + item.prop) ||
                  item.disable === 1
                "
              ></BaseAutocomplete>
            </BaseTooltip>
          </div>
        </BaseCheckboxGroup>
      </BaseCol>
      <BaseCol :span="12">
        <span style="font-weight: bold">其他信息</span>
        <div style="margin: 10px 0 10px 30px">
          <BaseCheckbox v-model="other" @change="otherCheckAll">
            全选
          </BaseCheckbox>
        </div>
        <BaseCheckboxGroup v-model="checkedOther" @change="otherChecked">
          <div
            style="display: flex; align-items: center; margin-bottom: 16px"
            v-for="(item, index) in otherList"
            :key="index"
          >
            <div
              v-if="[5, 20].includes(+projectType)"
              style="
                font-size: 14px;
                color: #c0c4cc;
                margin-right: 10px;
                text-align: center;
                width: 20px;
              "
            >
              {{ index + 1 }}
            </div>
            <BaseCheckbox
              @change="
                e => {
                  clearCheck(e, index, 'otherList');
                }
              "
              :value="'other' + item.prop"
              :label="'other' + item.prop"
            ></BaseCheckbox>
            <BaseTooltip
              v-if="
                item.dataType === 1 ||
                item.dataType === 4 ||
                item.dataType === 5 ||
                item.dataType === 9 ||
                item.dataType === 32
              "
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <BaseInput
                style="width: 350px"
                :placeholder="item.label"
                v-model="item.conditionKey"
                :disabled="
                  !checkedOther.includes('other' + item.prop) ||
                  item.disable === 1
                "
              ></BaseInput>
            </BaseTooltip>
            <!-- dataType:8 数字填空题 为区间 -->
            <div
              style="display: flex; align-items: center"
              v-else-if="item.dataType === 8"
            >
              <BaseTooltip
                class="item"
                effect="dark"
                :content="item.label"
                placement="top"
                :disabled="item.label.length < 8"
              >
                <BaseInput
                  style="width: 150px"
                  :placeholder="item.label"
                  v-model="item.conditionKey[0]"
                  @focus="
                    item.conditionKey = Array.isArray(item.conditionKey)
                      ? item.conditionKey
                      : ['', '']
                  "
                  @input="
                    e => {
                      item.conditionKey[0] = limitToNum(e);
                    }
                  "
                  :disabled="
                    !checkedOther.includes('other' + item.prop) ||
                    item.disable === 1
                  "
                ></BaseInput>
              </BaseTooltip>
              <span style="font-size: 16px; margin: 0 8px">——</span>
              <BaseTooltip
                class="item"
                effect="dark"
                :content="item.label"
                placement="top"
                :disabled="item.label.length < 8"
              >
                <BaseInput
                  style="width: 150px"
                  :placeholder="item.label"
                  v-model="item.conditionKey[1]"
                  @focus="
                    item.conditionKey = Array.isArray(item.conditionKey)
                      ? item.conditionKey
                      : ['', '']
                  "
                  @input="
                    e => {
                      item.conditionKey[1] = limitToNum(e);
                    }
                  "
                  :disabled="
                    !checkedOther.includes('other' + item.prop) ||
                    item.disable === 1
                  "
                ></BaseInput>
              </BaseTooltip>
            </div>
            <BaseTooltip
              v-else-if="
                item.dataType === 2 ||
                item.dataType === 6 ||
                item.dataType === 18
              "
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 8"
            >
              <BaseDatePicker
                v-if="item.dataType === 2"
                v-model="item.conditionKey"
                type="daterange"
                value-format="YYYY-MM-DD"
                range-separator="至"
                :start-placeholder="item.label + '起'"
                :end-placeholder="item.label + '止'"
                :disabled="!checkedOther.includes('other' + item.prop)"
              ></BaseDatePicker>
              <BaseDatePicker
                v-if="item.dataType === 18"
                v-model="item.conditionKey"
                type="daterange"
                value-format="YYYY-MM-DD"
                range-separator="至"
                :start-placeholder="item.label + '起'"
                :end-placeholder="item.label + '止'"
                :disabled="!checkedOther.includes('other' + item.prop)"
              ></BaseDatePicker>
              <BaseDatePicker
                v-else-if="item.dataType === 6"
                v-model="item.conditionKey"
                style="width: 350px"
                type="monthrange"
                value-format="YYYY-MM"
                range-separator="至"
                :start-placeholder="item.label + '起'"
                :end-placeholder="item.label + '止'"
                :disabled="!checkedOther.includes('other' + item.prop)"
              ></BaseDatePicker>
            </BaseTooltip>
            <BaseTooltip
              v-else-if="item.dataType === 3 || item.dataType === 7"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <BaseSelect
                style="width: 350px"
                v-model="item.conditionKey"
                clearable
                :placeholder="item.label"
                :disabled="!checkedOther.includes('other' + item.prop)"
                :options="
                  item.options.map(citem => {
                    return {
                      label: citem.label ? citem.label : citem,
                      value: citem.value ? citem.value : citem
                    };
                  })
                "
              ></BaseSelect>
            </BaseTooltip>
            <BaseTooltip
              v-else-if="item.dataType === 17"
              class="item"
              effect="dark"
              :content="item.label"
              placement="top"
              :disabled="item.label.length < 21"
            >
              <BaseCascader
                style="width: 350px"
                v-model="item.conditionKey"
                clearable
                :placeholder="item.label"
                :disabled="!checkedOther.includes('other' + item.prop)"
                :options="item.options"
              ></BaseCascader>
            </BaseTooltip>
          </div>
        </BaseCheckboxGroup>
      </BaseCol>

      <BaseAlert
        title="注：选择相应的字段后，将会在列表显示"
        type="warning"
        :closable="false"
        show-icon
      ></BaseAlert>
    </BaseRow>
    <template #footer>
      <BaseButton type="default" @click="props.remove">取 消</BaseButton>
      <BaseButton type="primary" @click="save">确 定</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" setup>
import { ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseRow,
  BaseCol,
  BaseButton,
  BaseCheckbox,
  BaseCheckboxGroup,
  BaseTooltip,
  BaseInput,
  BaseDatePicker,
  BaseSelect,
  BaseCascader,
  BaseAutocomplete,
  XrkMessage,
  BaseAlert
} from 'xrk-components';
import { getDisplayInfo } from '../data-source/apis';
import { storage } from '@/utils/storage';
import { getColumnsCheckedKey } from '@/components/biz/biz-table-set-field/src/hooks';

const props = withDefaults(
  defineProps<{
    projectId: string | number;
    projectType: string | number;
    remove?: () => void;
  }>(),
  {}
);

const emits = defineEmits(['confirm']);

//基本信息
const basic = ref<boolean>(false); //默认是否全选
const checkedBasic = ref([]); //选取的基本信息list
const basicList = ref([]); //用做渲染基本信息控件的list

//其他信息
const other = ref<boolean>(false); //默认是否全选
const checkedOther = ref([]);
const otherList = ref([]);

const storeKey = getColumnsCheckedKey(props.projectId + '_task-auto-check');

const limitToNum = data => {
  let num = data
    .replace(/[^\d.-]/g, '')
    //只允许一个小数点
    .replace(/^\./g, '')
    .replace(/\.{2,}/g, '.')
    //只能输入小数点后两位
    .replace('.', '$#$')
    .replace(/\./g, '')
    .replace('$#$', '.')
    // eslint-disable-next-line no-useless-escape
    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
  return num;
};

const clearCheck = (e, i, list) => {
  if (!e) {
    const map = {
      basicList: basicList.value,
      otherList: otherList.value
    };
    map[list][i].conditionKey = '';
  }
};

const searchRule = list => {
  let ruleError = list.find(item => {
    if (+item.dataType === 8 && Array.isArray(item.conditionKey)) {
      //因为区间搜索需要全部填或者全部不填
      //所以判断第一个字段没有值并且第二个字段有值返回 error
      if (!item.conditionKey[0] && item.conditionKey[1]) {
        XrkMessage.error('请填写正确的数字区间');
        return item;
      } else if (!item.conditionKey[1] && item.conditionKey[0]) {
        XrkMessage.error('请填写正确的数字区间');
        return item;
      } else if (isNaN(+item.conditionKey[0]) || isNaN(+item.conditionKey[1])) {
        XrkMessage.error('请填写正确的数字区间');
        return item;
      } else if (+item.conditionKey[0] > +item.conditionKey[1]) {
        XrkMessage.error('请填写正确的数字区间');
        return item;
      }
    }
  });
  if (ruleError) {
    return false;
  } else {
    return true;
  }
};

//基本信息全选
const basicCheckAll = val => {
  const basicCheckAllList = basicList.value.map((item, index) => {
    clearCheck(val, index, 'basicList');
    return 'basic' + item.prop;
  });
  checkedBasic.value = val ? basicCheckAllList : [];
};

const basicChecked = value => {
  basic.value = value.length === basicList.value.length;
};
//其他信息全选
const otherCheckAll = val => {
  const otherCheckAllList = otherList.value.map((item, index) => {
    clearCheck(val, index, 'otherList');
    return 'other' + item.prop;
  });
  checkedOther.value = val ? otherCheckAllList : [];
};
const otherChecked = value => {
  other.value = value.length === otherList.value.length;
};

//查看项目是否有缓存数据
const taskCheck = () => {
  const isCache = storage.get(storeKey);
  if (isCache) {
    // 如果有缓存
    checkedBasic.value = JSON.parse(isCache).checkedBasic;
    checkedOther.value = JSON.parse(isCache).checkedOther;

    other.value = checkedOther.value.length === otherList.value.length; //其他信息全选按钮
    basic.value = checkedBasic.value.length === basicList.value.length; //基本信息全选按钮
  }
  // else {
  //   otherCheckAll(true); //其他默认信息全选
  //   checkedBasic.value = ['basicfullName', 'basicphone']; //基本信息默认选中人员和电话
  // }
};

// const clearAll = () => {
//   basicList.value.forEach(item => {
//     if (checkedBasic.value.indexOf('basic' + item.prop) === -1) {
//       item.conditionKey = null;
//     }
//   });
//   otherList.value.forEach(item => {
//     if (checkedOther.value.indexOf('other' + item.prop) === -1) {
//       item.conditionKey = null;
//     }
//   });
// };

const save = () => {
  //所选项条数
  const isSelectNum = checkedBasic.value.length + checkedOther.value.length;
  if (isSelectNum < 1) {
    XrkMessage.error('至少选择一项展示');
    return;
  }
  //筛选选中的数据
  const basicCheckedList = basicList.value.filter(item => {
    return checkedBasic.value.indexOf('basic' + item.prop) !== -1;
  });
  const otherCheckedList = otherList.value.filter(item => {
    return checkedOther.value.indexOf('other' + item.prop) !== -1;
  });
  const list = [...basicCheckedList, ...otherCheckedList];
  //数字区间校验
  if (!searchRule(list)) {
    return;
  }
  const cacheCheck = {
    checkedBasic: [...checkedBasic.value],
    checkedOther: [...checkedOther.value]
  };
  //储存快捷审核需要的表头信息
  sessionStorage.setItem('quickCheckedList', JSON.stringify(list));
  //根据id储存快捷审核所选内容
  storage.set(storeKey, JSON.stringify(cacheCheck));
  emits('confirm');
  props.remove();
};

onMounted(() => {
  getDisplayInfo({
    projectId: props.projectId,
    sceneType: props.projectType
  }).then(res => {
    basicList.value = res.data.baseInfos.map(item => {
      return { ...item, conditionKey: '' };
    });
    otherList.value = res.data.generalExtendInfos.map(item => {
      return { ...item, options: JSON.parse(item.options), conditionKey: '' };
    });
    taskCheck();
  });
});
</script>

<style scoped lang="scss">
.xrk-select__tags {
  margin-left: 10px;
}
.xrk-checkbox__label {
  display: none;
}
.xrk-date-editor {
  margin-left: 10px;
}

.xrk-row {
  max-height: 70vh;
}
.dialog-footer {
  text-align: center;
}
.quick-tips {
  background: #fef0f0;
  color: #f56c6c;
  line-height: 50px;
  width: 97%;
  margin-top: 20px;
  padding-left: 10px;
  display: inline-block;
  clear: both;
}
</style>
